import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setOk(data.message); setTimeout(() => nav("/login"), 1500);
    } catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-[hsl(222_47%_6%)] p-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(217_33%_14%)] p-8 shadow-2xl">
        <h1 className="font-head text-2xl font-bold text-white">Set a new password</h1>
        {!token && <p className="mt-2 text-sm text-rose-400">Missing reset token. Use the link from your email.</p>}
        {ok ? (
          <p className="mt-6 rounded-lg bg-emerald-500/10 px-3 py-3 text-sm text-emerald-400" data-testid="reset-message">{ok}</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label className="text-slate-300">New password</Label>
              <Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></div>
            {err && <p className="rounded-lg bg-rose-500/10 px-3 py-2 text-sm text-rose-400">{err}</p>}
            <Button type="submit" disabled={busy || !token} data-testid="reset-submit" className="h-11 w-full font-semibold">{busy ? "Updating…" : "Update password"}</Button>
          </form>
        )}
        <div className="mt-6 text-center"><Link to="/login" className="text-sm text-blue-400 hover:underline">Back to sign in</Link></div>
      </div>
    </div>
  );
}
